<div class="tw-flex tw-flex-col tw-gap-4">
  <div
    class="tw-flex tw-flex-col tw-gap-4 tw-rounded-2xl tw-bg-color-surface-card tw-p-4 tw-shadow-elevation-card"
  >
    <span
      class="tw-font-montserrat tw-text-[13px] tw-font-semibold tw-uppercase tw-leading-none tw-tracking-[0.08em] tw-text-color-text-secondary"
      >{{ "howTeamSharingWorksTitle" | i18n }}</span
    >

    <div class="tw-flex tw-flex-col">
      @for (step of steps; track step.titleKey; let i = $index) {
        @if (i > 0) {
          <div class="tw-flex tw-w-full tw-flex-col tw-py-3">
            <div class="tw-h-px tw-w-full tw-bg-white/[.82]"></div>
            <div class="tw-h-px tw-w-full tw-bg-black/10"></div>
          </div>
        }
        <div class="tw-flex tw-items-start tw-gap-3">
          <span
            class="tw-flex tw-h-7 tw-w-7 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-color-surface-brand tw-font-montserrat tw-text-[13px] tw-font-semibold tw-leading-none tw-text-color-intent-brand"
            >{{ i + 1 }}</span
          >
          <div class="tw-flex tw-flex-col tw-gap-1">
            <span
              class="tw-font-montserrat tw-text-sm tw-font-semibold tw-leading-none tw-text-color-text-default"
              >{{ step.titleKey | i18n }}</span
            >
            <span
              class="tw-font-montserrat tw-text-xs tw-font-medium tw-leading-[145%] tw-text-color-text-secondary"
              >{{ step.descriptionKey | i18n }}</span
            >
          </div>
        </div>
      }
    </div>

    <div
      class="tw-flex tw-w-full tw-flex-col tw-rounded-xl tw-bg-color-surface-sunken tw-px-[14px] tw-py-[10px]"
    >
      <span
        class="tw-font-montserrat tw-text-xs tw-font-medium tw-leading-[145%] tw-text-color-text-on-brand"
        >{{ "teamsHowItWorksNote" | i18n }}</span
      >
    </div>
  </div>

  <div
    class="tw-flex tw-flex-col tw-gap-4 tw-rounded-2xl tw-bg-color-surface-card tw-p-4 tw-shadow-elevation-card"
  >
    <span
      class="tw-font-montserrat tw-text-[13px] tw-font-semibold tw-uppercase tw-leading-none tw-tracking-[0.08em] tw-text-color-text-secondary"
      >{{ "statusBadgesTitle" | i18n }}</span
    >

    <div class="tw-flex tw-flex-col">
      @for (key of statusKeys; track key; let i = $index) {
        @if (i > 0) {
          <div class="tw-flex tw-w-full tw-flex-col tw-py-3">
            <div class="tw-h-px tw-w-full tw-bg-white/[.82]"></div>
            <div class="tw-h-px tw-w-full tw-bg-black/10"></div>
          </div>
        }
        <div class="tw-flex tw-items-center tw-gap-3">
          <span [ngClass]="badgeClass[key]">{{ badgeLabelKey[key] | i18n }}</span>
          <span
            class="tw-font-montserrat tw-text-[13px] tw-font-medium tw-leading-[140%] tw-text-color-text-secondary"
            >{{ badgeDescriptionKey[key] | i18n }}</span
          >
        </div>
      }
    </div>
  </div>
</div>
